import brand from '@/config/brand';
import { siteContactPublicRef } from '@/composables/useSiteContact';
import { buildPageTitle } from '@/utils/siteTitle';

function setMeta(nameOrProperty, content, isProperty = false) {
  if (!content) return;
  const attr = isProperty ? 'property' : 'name';
  let el = document.querySelector(`meta[${attr}="${nameOrProperty}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, nameOrProperty);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
}

function pickConfig() {
  return siteContactPublicRef.value;
}

/** Actualiza title, og:*, canonical y meta SEO desde SiteConfig o fallbacks de brand/env. */
export function applySeoMeta(pageTitle) {
  const c = pickConfig();
  const storeName = (c && c.store_name) || brand.storeName;
  const slogan = (c && c.store_slogan) || brand.storeSlogan;
  const description =
    (c && c.store_description) ||
    process.env.VUE_APP_STORE_DESCRIPTION ||
    slogan;
  const siteUrl =
    process.env.VUE_APP_SITE_URL ||
    (typeof window !== 'undefined' ? window.location.origin : '');
  const ogImage =
    (c && c.og_image_url) ||
    process.env.VUE_APP_OG_IMAGE_URL ||
    `${siteUrl}/logo.png`;

  document.title = buildPageTitle(pageTitle);

  setMeta('description', description);
  setMeta('keywords', (c && c.seo_keywords) || process.env.VUE_APP_SEO_KEYWORDS || '');
  setMeta('author', storeName);
  setMeta('geo.region', (c && c.geo_region) || brand.geoRegion);
  setMeta('geo.placename', (c && c.geo_placename) || process.env.VUE_APP_GEO_PLACENAME || '');

  setMeta('og:type', 'website', true);
  setMeta('og:title', buildPageTitle(pageTitle), true);
  setMeta('og:description', description, true);
  setMeta('og:image', ogImage, true);
  if (siteUrl) {
    setMeta('og:url', siteUrl, true);
    setLink('canonical', siteUrl);
  }
}
